export enum UserTheme {
  Light = 'light',
  Dark = 'dark',
}

export const UserThemeList = [
  { name: 'Light', value: UserTheme.Light },
  { name: 'Dark', value: UserTheme.Dark },
];
